import IpcRouter from '@shared/ipc/IpcRouter.ts'
import { ClipboardRecordType, ClipboardHistoryItem } from '@renderer/chat/types'
import type {
  AddPrivacyRuleResult,
  PrivacyDomainMetadata,
  PrivacyFilterRule,
  PrivacyFilterRuleInput,
  PrivacyFiltersSnapshot,
  PrivacyPolicyDecision,
} from '@shared/utils/privacy-filtering.ts'

export interface ContextDbIpcRouterType {
  getClipboardHistory: ({
    limit,
    offset,
    since,
    type,
  }: {
    limit?: number
    offset?: number
    since?: number
    type?: ClipboardRecordType
  }) => Promise<ClipboardHistoryItem[]>
  getClipboardCount: () => Promise<number>
  searchClipboardHistory: ({
    query,
    limit,
    type,
  }: {
    query: string
    limit?: number
    type?: ClipboardRecordType
  }) => Promise<ClipboardHistoryItem[]>
  clearClipboardHistory: () => Promise<boolean>
  getScreenshotCount: () => Promise<number>
  clearScreenshotHistory: () => Promise<boolean>
  deleteClipboardItem: (id: number) => Promise<void>
  deleteClipboardByApp: (appName: string) => Promise<void>
  deleteClipboardByDomain: (domain: string) => Promise<void>
  getPrivacyFilters: () => Promise<PrivacyFiltersSnapshot>
  addPrivacyRule: ({
    rule,
    overrideConflict,
  }: {
    rule: PrivacyFilterRuleInput
    overrideConflict?: boolean
  }) => Promise<AddPrivacyRuleResult>
  updatePrivacyRule: ({
    id,
    rule,
    overrideConflict,
  }: {
    id: number
    rule: PrivacyFilterRuleInput
    overrideConflict?: boolean
  }) => Promise<AddPrivacyRuleResult>
  removePrivacyRule: (id: number) => Promise<boolean>
  resetPrivacyFiltersToDefaults: () => Promise<boolean>
  checkPrivacyRuleConflict: (rule: PrivacyFilterRuleInput) => Promise<PrivacyFilterRule | null>
  refreshPrivacyDomainMetadata: (domain: string) => Promise<PrivacyDomainMetadata | null>
  evaluateFocusedWindowPrivacy: (focusedWindow: {
    appName?: string | null
    windowTitle?: string | null
    url?: string | null
  }) => Promise<PrivacyPolicyDecision>
}

class ContextDbRouter extends IpcRouter<ContextDbIpcRouterType> {
  constructor() {
    super('context-db', {
      getClipboardHistory: true,
      getClipboardCount: true,
      searchClipboardHistory: true,
      clearClipboardHistory: true,
      getScreenshotCount: true,
      clearScreenshotHistory: true,
      deleteClipboardItem: true,
      deleteClipboardByApp: true,
      deleteClipboardByDomain: true,
      getPrivacyFilters: true,
      addPrivacyRule: true,
      updatePrivacyRule: true,
      removePrivacyRule: true,
      resetPrivacyFiltersToDefaults: true,
      checkPrivacyRuleConflict: true,
      refreshPrivacyDomainMetadata: true,
      evaluateFocusedWindowPrivacy: true,
    })
  }
}

export default ContextDbRouter
